import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { siteConfig } from "@/data/siteConfig";
import { useSiteContent } from "@/context/ContentContext";

const cols = [
  { title: "Company", links: [["About", "/about"], ["Quality & Supply", "/quality-supply"], ["Gallery", "/gallery"], ["Contact", "/contact"]] },
  { title: "Parts", links: [["All Parts", "/parts"], ["Request a Quote", "/request-a-quote"], ["FAQ", "/faq"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms", "/terms"]] },
];

export function Footer() {
  const { company } = siteConfig;
  const { contact } = useSiteContent();
  return (
    <footer className="relative bg-ink text-white overflow-hidden" data-testid="site-footer">
      <div className="tech-grid-dark absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <Logo variant="light" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              {company.name} supplies aftermarket tractor, agricultural implement, backhoe loader and 3-point linkage parts with a focus on dependable performance and professional international supply.
            </p>
            <p className="mt-2 max-w-sm text-xs text-white/40">{company.divisionNote}</p>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <a href={`tel:${contact.phone}`} className="flex items-center gap-2 hover:text-amber transition-colors"><Phone className="w-4 h-4 text-amber" />{contact.phoneDisplay}</a>
              <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-amber transition-colors"><Mail className="w-4 h-4 text-amber" />{contact.email}</a>
              <span className="flex items-center gap-2"><MapPin className="w-4 h-4 text-amber" />{contact.address}</span>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display uppercase text-lg tracking-wide text-white">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-white/60 hover:text-amber transition-colors duration-200">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {company.name}. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">Industrial · Technical · International</span>
        </div>
      </div>
    </footer>
  );
}
